import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // desactivo el modo estricto porque si no me descontrola las vistas
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

